import { render, staticRenderFns } from "./rolemanagetable.vue?vue&type=template&id=2274f91a&scoped=true&"
import script from "./rolemanagetable.vue?vue&type=script&lang=js&"
export * from "./rolemanagetable.vue?vue&type=script&lang=js&"
import style0 from "./rolemanagetable.vue?vue&type=style&index=0&id=2274f91a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2274f91a",
  null
  
)

export default component.exports